import React from 'react';

import { ChakraFlex, ChatUser } from '@equip.health/ui';
import { GroupChannel } from '@sendbird/chat/groupChannel';

import {
  getAdminMessageText,
  getLastChannelMessage,
  getLastChannelMessageRelativeDate,
  isExternalChannel,
  isInactiveRotatedChannel,
} from '~/lib/util/chat/chat.utils';
import { getChannelName } from '~/lib/util/chat/chatChannel.util';

import ChannelDivider from './ChannelDivider';
import ChannelTile from './ChannelTile';

const idPrefix = 'channel';
const idPostfix = 'list';

interface ChannelListProps {
  channels: GroupChannel[];
  id: string;
  onChannelSelected: (channel: string, isRotated?: boolean) => void;
  patientName: string;
  selectedChannelUrl: string;
}

const ChannelListPanel = React.forwardRef<HTMLInputElement, ChannelListProps>(
  (
    { channels, id, onChannelSelected, selectedChannelUrl }: ChannelListProps,
    ref?: React.ForwardedRef<HTMLInputElement>,
  ) => {
    return (
      <ChakraFlex
        direction="column"
        gridGap="12px"
        height="100%"
        id={`${idPrefix}-container__${id}__${idPostfix}`}
        overflow="auto"
        ref={ref}
        width="100%"
      >
        {(channels ?? []).map((channel, index) => (
          <React.Fragment key={channel.url}>
            <ChannelTile
              channelMembers={channel?.members as ChatUser[]}
              channelTitle={getChannelName(channel)}
              hasUnreadMessages={channel?.unreadMessageCount > 0}
              id={id}
              isChannelInactiveRotated={isInactiveRotatedChannel(channel)}
              isExternalChannel={isExternalChannel(channel.url)}
              isLastFile={channel.lastMessage?.isFileMessage()}
              isSelected={selectedChannelUrl === channel.url}
              key={channel?.url}
              lastMessage={getAdminMessageText(
                getLastChannelMessage(channel.lastMessage),
                '',
              )}
              lastMessageRelativeDate={getLastChannelMessageRelativeDate(
                channel.lastMessage,
              )}
              onClick={() => {
                onChannelSelected(channel?.url);
              }}
            />
            <ChannelDivider index={index} totalCount={channels.length} />
          </React.Fragment>
        ))}
      </ChakraFlex>
    );
  },
);

ChannelListPanel.displayName = 'ChannelListPanel';

export default ChannelListPanel;
